export const BAA_TRACKING_TEXT = {
  TIME_SELECTED: 'timeSelected',
  FINISH_CONFIRMED_BOOKING: 'Continue Application',
  CANCEL_APPOINTMENT: 'Cancel appointment',
  CONTINUE: 'Continue',
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  RESCHEDULE: 'Reschedule',
  BACK_TO_SELECTION: 'Back to selection',
  BOOK_APPOINTMENT: 'Book appointment',
  REFRESH: 'refresh',
  VIEW_NOTES: 'View notes',
  APPOINTMENT_TYPE: 'Appointment Type',
  TO_APPLICATION_DASHBOARD: 'To application dashboard',
  APPLY_BUTTON: 'Apply',
  EDIT: 'Edit',
  GO_TO_HOMEPAGE: 'go to homepage',
  SELECT_DATE_AND_TIME: 'select date & time',
  BOOK_WITH_NEW_BROKER: 'book with new',
  BOOK_WITH_CURRENT_BROKER: 'book with current',
  BACK_LINK: 'back',
  BUYERS_AGENT_APPOINTMENT: 'Book buyers agent appointment',
  BROKER_APPOINTMENT: 'Book broker appointment',
};

export const BAA_F2F_RADIO_SELECTION = {
  STORE_NAME: 'Store Name',
  ANOTHER_LOCATION: 'Another Location',
};
export const BAA_TRACKING_PURPOSE = {
  EDIT_ADDRESS: 'edit address',
  EDIT_APPOINTMENT_OWNER: 'Edit Appointment Owner',
};

export const BAA_TRACKING_MODAL_TYPES = {
  CONFIRMATION: 'Confirmation',
};

export const MENU_NAME = {
  KEBAB_MENU: 'Kebab Menu',
};

export const BAA_TRACKING_POSITION_PAGE = 'page';
export const BAA_TRACKING_BUTTON_CLICKED = 'Button Clicked';
export const BAA_TRACKING_LINK_CLICKED = 'Link Clicked';
export const BAA_TRACKING_APPT_TYPE = 'Appointment Type';
export const BAA_TRACKING_APPT_FORM_ELEMENT_ANSWER = 'Form Element Answered';
export const BAA_TRACKING_PAGE_VIEWED = 'page viewed';
export const BAA_TRACKING_RADIO_BUTTON_SELECTED = 'Radio Button Selected';
export const BAA_TRACKING_DROPDOWN_SELECTED = 'Drop down selected';
export const BAA_TRACKING_MENU_ELEMENT_CLICKED = 'Menu Element Clicked';

export const BAA_TRACKING_POSITION = {
  MAIN_TIME: 'main time selection screen',
  PRE_TIME: 'pre time selection overlay',
};

export const BAA_TRACKING_APPT_TYPES = {
  PHONE: 'Over the phone',
  IN_PERSON: 'In person',
};

export const BAA_TRACKING_APPT_RADIO_BUTTON_TITLE = 'Where Would You Like To Meet?';
export const BAA_TRACKING_APPT_EMPTY_AVAILABILITY_LOG_MESSAGE = 'No appointments available alert shown.';
export const BAA_TRACKING_APPT_TIME_SELECTION_UNAUTHENTICATED_RENDER_LOG_MESSAGE =
  'Time Selection display rendered by unauthenticated user.';
